import { ConnectProto } from "@racoon/api";
import { getJobFactContainerCount, getJobFactVolume, getJobVolume } from "~/shared/lib/job-metrics";
import { plannedContainerCount } from "~/shared/lib/job-containers";

export function getRouteJobsCount(route: ConnectProto.Route): number {
  return route.jobs?.length ?? 0;
}

/** Jobs across the routes; with `status`, only the jobs in it. */
export function getRoutesJobsCount(
  routes: ConnectProto.Route[],
  status?: ConnectProto.JobStatus,
): number {
  return routes.reduce(
    (acc, route) =>
      acc +
      (status === undefined
        ? getRouteJobsCount(route)
        : (route.jobs ?? []).filter((job) => job.status === status).length),
    0,
  );
}

export function getRouteTotalVolume(route: ConnectProto.Route): number {
  return (route.jobs ?? []).reduce((acc, job) => acc + getJobVolume(job), 0);
}

export function getRoutesContainerCount(routes: ConnectProto.Route[]): number {
  return routes.reduce((acc, route) => {
    const routeContainerCount = (route.jobs ?? []).reduce((jobAcc, job) => {
      const containers = plannedContainerCount(job);
      return jobAcc + (containers > 0 ? containers : 0);
    }, 0);

    return acc + routeContainerCount;
  }, 0);
}

/** A trip's containers actually serviced, on the same terms as its fact volume. */
export function getRouteFactContainerCount(route: ConnectProto.Route): number {
  return (route.jobs ?? []).reduce((acc, job) => acc + (getJobFactContainerCount(job) ?? 0), 0);
}

/** A trip's volume: what its jobs actually took, added up. */
export function getRouteFactVolume(route: ConnectProto.Route): number {
  return (route.jobs ?? []).reduce((acc, job) => acc + (getJobFactVolume(job) ?? 0), 0);
}

/**
 * "Рейс N" numbers in list order. A cancelled trip was never driven, so it gets
 * no number and the trips after it keep counting on from the previous one.
 */
export function getTripNumbers(routes: ConnectProto.Route[]): Map<bigint, number | undefined> {
  const numbers = new Map<bigint, number | undefined>();
  let next = 1;
  for (const route of routes) {
    numbers.set(route.id, route.status === ConnectProto.RouteStatus.CANCELLED ? undefined : next++);
  }
  return numbers;
}
